import { Page, Text, View, Document, StyleSheet, Image, Svg, Path } from '@react-pdf/renderer';
import API_URL from '../config';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontSize: 12,
  },
  container: {
    height: '22vh',
    width: '100%',
    flexDirection: 'row',
    border: '1px solid black',
    marginBottom: 10,
    padding: '20 10',
  },
  personInfo: {
    width: '25%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: '1px dotted gray',
    position: 'relative',
  },
  temp: {
    height: '10px',
    width: '10px',
    backgroundColor: '#29b643',
    position: 'absolute',
    top: '18px',
    left: '75%',
    zIndex: 999,
    // borderRadius: '50%',
    borderRadius: 50,
  },
  personDetail: {
    width: '75%',
    padding: '0 13px',
  },
  outerImage: {
    border: '1.5px solid #29b643',
    // borderRadius: '50%',
    borderRadius: 50,
    height: '70%',
    padding: 3,
    display: 'grid',
  },
  image: {
    borderRadius: 50,
    // borderRadius: '50%',
    display: 'grid',
    placeSelf: 'center',
    overflow: 'hidden',
    aspectRatio: 1,
    height: '100px',
  },
  personName: {
    fontSize: 13,
    margin: '2px 0',
    color: 'darkblue',
  },
  personContact: {
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 13,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1.5px dotted grey',
    paddingBottom: 10,
  },
  left: {
    width: '70%',
  },
  headerText: {
    // fontWeight: 'bolder',
    fontWeight: 'bold',
    marginBottom: 10,
    fontSize: '15px',
  },
  headerText2: {
    // fontWeight: 'bolder',
    fontWeight: 'bold',
    marginBottom: 5,
    fontSize: '15px',
    color: 'red',
  },
  headerImg: {
    objectFit: 'contain',
    height: '40px',
  },
  footer: {
    padding: '8px 0',
    fontSize: 11,
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '95%',
  },
  footerItem: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 3,
  },
  footertext: {
    fontSize: '13px',
    paddingTop: '2px',
  },
  footerIcon: {
    fontSize: 13,
    backgroundColor: '#25a03b',
    // borderRadius: '50%',
    borderRadius: 50,
    padding: 2,
    color: 'white',
    marginRight: 5,
  },
  outerIcon: {
    backgroundColor: '#29b643',
    // borderRadius: '50%',
    borderRadius: 50,
    height: '18px',
    width: '18px',
    display: 'grid',
    padding: '2.3px',
    marginRight: '3px',
  },
  iconstyle: {
    width: '13px',
    height: '13px',
  },
});
const styles2 = StyleSheet.create({
  page: {
    backgroundColor: 'white',
    color: 'white',
    fontSize: 14,
  },
  chapterMain: {
    margin: 15,
    padding: 15,
    paddingTop: 0,
    border: '1px solid black',
  },
  image: {
    width: 90,
    margin: '0 auto',
    height: 60,
    padding: 10,
  },
  heading: {
    height: "40px",
    backgroundColor: '#543F3F',
    border: '3px solid #FEBD12',
    marginBottom: 7,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  members: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  memberContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 6,
    // height: 'calc((100vh - 181px) / 15)',
    height: '40px',
  },
  name: {
    backgroundColor: '#B55017',
    border: '3px solid #FEBD12',
    width: '70%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 10px',
  },
  left: {
    fontWeight: 400,
    width: '60%',
  },
  right: {
    fontWeight: 300,
    width: '40%',
  },
  number: {
    backgroundColor: '#003AB3',
    width: '30%',
    border: '3px solid #FEBD12',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const Member = ({ name, role, number }) => (
  <View style={styles2.memberContainer}>
    <View style={styles2.name}>
      <Text style={styles2.left}>{name}</Text>
      <Text style={styles2.right}>- &nbsp; {role}</Text>
    </View>
    <View style={styles2.number}>
      <Text>{number}</Text>
    </View>
  </View>
);

const MyDocument = ({ data }) => {
  const pages = [];
  //const baseUrl = 'https://rmb.cognisunsandbox.com:4014/';
  const baseUrl = API_URL;

  // Split data into chunks of 4 for each page
  for (let i = 0; i < data?.length; i += 4) {
    const chunk = data?.slice(i, i + 4);
    while (chunk.length < 4) {
      chunk.push(null);
    }
    pages.push(chunk);
  }

  return (
    <Document>
      
       { /* <Page size="A4" style={{width:"90%",height:"90%"}}>
       <Image src={home} style={{height:"90%"}}/>
      </Page>
      <Page size="A4" style={{width:"90%",height:"90%"}}>
       <Image src={founder} style={{height:"90%"}}/>
      </Page>
      <Page size="A4" style={{width:"90%",height:"90"}}>
       <Image src={chapter} style={{height:"90%"}}/>
      </Page> */}
      {pages.map((pageData, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          {pageData.map((item, itemIndex) => (
            item ? (
              <View style={styles.container} key={itemIndex}>
                <View style={styles.personInfo}>
                  <View style={styles.temp}></View>
                  <View style={styles.outerImage}>
                    {/* <View style={{ border: '1.5px solid #29b643', borderRadius: '50%' }}> */}
                    <View style={{ border: '1.5px solid #29b643', borderRadius: 50 }}>
                      <View style={styles.image}>
                        {/* {item.profilepicture && <Image src={`${baseUrl}${item.profilepicture}`} style={{ height: '100%', aspectRatio: 1 }} />} */}
                        {item.profilepicture && <Image src={`${item.profilepicture}`} style={{ height: '100%', aspectRatio: 1 }} />}
                        {/* {item.profilepicture && <Image src="https://as2.ftcdn.net/v2/jpg/05/49/98/39/1000_F_549983970_bRCkYfk0P6PP5fKbMhZMIb07mCJ6esXL.jpg" style={{ height: '100%', aspectRatio: 1 }} />} */}
                      </View>
                    </View>
                  </View>
                  <Text style={styles.personName}>{item.FullName}</Text>
                  <View style={styles.personContact}>
                    <View style={styles.outerIcon}>
                      <Svg viewBox="0 0 24 24" style={styles.iconstyle}><Path d="M6.62 10.79a15.15 15.15 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.11-.27 11.36 11.36 0 0 0 3.58.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.36 11.36 0 0 0 .57 3.58 1 1 0 0 1-.27 1.11z" fill="white" /></Svg>
                    </View>
                    <Text>+{item.countrycode + ' ' + item.phonenum}</Text>
                  </View>
                </View>
                <View style={styles.personDetail}>
                  <View style={styles.header}>
                    <View style={styles.left}>
                      <Text style={styles.headerText}>{item.businessname}</Text>
                      <Text style={styles.headerText2}>{item.businesscategory}</Text>
                    </View>
                    {/* {item.logo && <Image src={`${baseUrl}${item.logo}`} style={styles.headerImg} />} */}
                    {item.logo && <Image src={item.logo} style={styles.headerImg} />}
                  </View>
                  <View style={styles.footer}>
                    {item.email && (
                      <View style={styles.footerItem}>
                        <View style={styles.outerIcon}>
                          <Svg viewBox="0 0 24 24" style={styles.iconstyle}><Path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="white" /></Svg>
                        </View>
                        <Text style={styles.footertext}>{item.email}</Text>
                      </View>
                    )}
                    {item.website && (
                      <View style={styles.footerItem}>
                        <View style={styles.outerIcon}>
                          <Svg viewBox="0 0 24 24" style={styles.iconstyle}><Path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.53c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.4z" fill="white" /></Svg>
                        </View>
                        <Text style={styles.footertext}>{item.website}</Text>
                      </View>
                    )}
                    {item.fullAdress && (
                      <View style={styles.footerItem}>
                        <View style={styles.outerIcon}>
                          <Svg viewBox="0 0 24 24" style={styles.iconstyle}><Path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="white" /></Svg>
                        </View>
                        <Text style={styles.footertext}>{item.fullAdress}</Text>
                      </View>
                    )}
                  </View>
                </View>
              </View>
            ) : (
              <View style={styles.container} key={itemIndex}></View>
            )
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default MyDocument;
